import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingIndicator } from '@components';
import { getRequerimentosStatus } from '../../../../store/requerimentos/thunks';
import { DeferidoItem } from './components/DeferidoItem';

export const Deferidos = () => {
  const dispatch = useDispatch();
  const deferidos = useSelector((state) => state.requerimentos.deferido);
  const isLoading = useSelector((state) => state.requerimentos.loadingStatus);

  useEffect(() => {
    dispatch(getRequerimentosStatus({ status: 'deferido' }));
  }, [dispatch]);

  return isLoading ? (
    <LoadingIndicator />
  ) : (
    <div>
      {deferidos.map((requerimento) => {
        return (
          <DeferidoItem
            key={requerimento.Protocolo}
            requerimento={requerimento}
          />
        );
      })}
      {deferidos.length === 0 && (
        <div className="card">
          <div className="card-body">
            <p>Você não possui requerimentos deferidos</p>
          </div>
        </div>
      )}
    </div>
  );
};
